jQuery(function($) {

  $('.form__select').each(function() {
    var container = $(this);
    var text = $('.form__select__text', container);
    var select = $('select', container);
    var selectedText = $('option:selected', select).text();
    text.text(selectedText);
    select.on('change', function() {
      var selectedText = $('option:selected', select).text();
      text.text(selectedText);
    });
  });

  var toggleCheckbox = function(elem) {
    if ($(elem).attr('aria-checked') == 'false') {
      $(elem).attr('aria-checked', 'true');
    } else {
      $(elem).attr('aria-checked', 'false');
    }
  }

  $('.form__checkbox').on('click', function() {
    toggleCheckbox(this);
  });

  $('.form__checkbox').bind('keypress', function(e) {
    if (e.keyCode == 32) {
      toggleCheckbox(this);
    }
    e.preventDefault();
  });

});
